module.exports = __webpack_public_path__ + "static/img/cloud_logo.6fe346e2.jpeg";